<div class="page-preview">
  <h2 class="page-preview__title font-canelablack-primary">
    {{ data.title }}
  </h2>

  <button class="dialog-close-button" [mat-dialog-close]="false">
    <mat-icon svgIcon="close"></mat-icon>
  </button>

  <iframe
    [frameBorder]="0"
    [src]="data.url | DOMSafeUrl"
    class="document-viewer-iframe"
  >
  </iframe>
</div>
